import { StudentListCategoriesAdmin } from '@features/student-lists/components/StudentListCategoriesAdmin'
import { meSessionQueryOptions } from '@features/me/queries'
import { canAccessPortalAdministration } from '@features/portal-administration/access'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/admin/student-lists')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(meSessionQueryOptions())
    const roles = session.actualStaffProfile?.roles.map((role) => role.code) ?? []
    if (!canAccessPortalAdministration(roles)) throw redirect({ to: '/home' })
  },
  component: StudentListCategoriesAdmin,
  staticData: { crumb: { label: 'Student Lists' } },
})
